/* eslint-disable promise/no-promise-in-callback */
import axios, { type AxiosResponse, type ResponseType } from 'axios'

import { API_URL, API_VERSION } from '@/constants'
import { AuthState } from '@/state'

const { token } = AuthState

const DEFAULT_RESPONSE_TYPE: ResponseType = 'json'
const SUCCESS_STATUS = [200, 201]

const axiosInstance = axios.create({
  baseURL: `${API_URL}/api/${API_VERSION}`,
})

axiosInstance.interceptors.request.use(
  async (config) => {
    config.headers['Content-Type'] =
      config.headers['Content-Type'] ?? 'application/json'

    // config.headers['ngrok-skip-browser-warning'] = 'test'

    config.responseType = DEFAULT_RESPONSE_TYPE

    if (token.peek() !== null) {
      config.headers.Authorization = `Bearer ${token.peek()}`
    }

    return config
  },
  async function (error) {
    return await Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  async (response: AxiosResponse) => {
    if (
      SUCCESS_STATUS.includes(response.data.status as number) ||
      SUCCESS_STATUS.includes(response.status)
    ) {
      return response.data
    }

    return await Promise.reject(response.data)
  },
  async function (error) {
    const response = error.response
    return await Promise.reject(response.data ?? error)
  }
)

export default axiosInstance
